export default __webpack_public_path__ + "static/media/loc-logo-depois.2399bfbc.webp";